<template>
    <button
            class="inline-flex justify-center w-full px-4 py-2 mt-3 text-base font-medium text-white bg-electric-600 border border-transparent rounded-md shadow-sm hover:bg-electric-700 focus:outline-hidden focus:ring-2 focus:ring-offset-2 focus:ring-electric-500 sm:col-start-2 sm:text-sm"
            type="button"
            @click.prevent="openConfirmation"
    >
        Let my subscription auto renew
    </button>
    <TransitionRoot :show="isOpen" as="template">
        <Dialog as="div" class="relative z-10" @close="closeConfirmation">
            <TransitionChild as="template" enter="ease-out duration-300" enter-from="opacity-0" enter-to="opacity-100"
                             leave="ease-in duration-200" leave-from="opacity-100" leave-to="opacity-0">
                <div class="fixed inset-0 transition-opacity bg-gray-500 bg-opacity-75"/>
            </TransitionChild>

            <div class="fixed inset-0 z-10 overflow-y-auto">
                <div class="flex items-end justify-center min-h-full p-4 text-center sm:items-center sm:p-0">
                    <TransitionChild as="template" enter="ease-out duration-300"
                                     enter-from="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
                                     enter-to="opacity-100 translate-y-0 sm:scale-100" leave="ease-in duration-200"
                                     leave-from="opacity-100 translate-y-0 sm:scale-100"
                                     leave-to="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95">
                        <DialogPanel

                                class="relative px-4 pt-5 pb-4 overflow-hidden text-left transition-all transform bg-white rounded-lg shadow-xl sm:my-8 sm:max-w-lg sm:w-full sm:p-6">
                            <div>
                                <div class="flex items-center justify-center w-12 h-12 mx-auto bg-green-100 rounded-full">
                                    <CheckIcon aria-hidden="true" class="w-6 h-6 text-green-600"/>
                                </div>
                                <div class="mt-3 text-center sm:mt-5">
                                    <DialogTitle as="h3" class="text-lg font-medium leading-6 text-gray-900">Keep My
                                        Subscription
                                    </DialogTitle>
                                    <div class="mt-2">
                                        <p class="text-sm text-clay-800">Your subscription will automatically renew on
                                            {{ membershipSummary.subscription.currentPeriodEndFormatted }}.</p>
                                    </div>
                                </div>
                            </div>
                            <div v-if="!reactivated"
                                 class="mt-5 sm:mt-6 sm:grid sm:grid-cols-2 sm:gap-3 sm:grid-flow-row-dense">
                                <button :disabled="processing"
                                        class="inline-flex justify-center w-full px-4 py-2 text-base font-medium text-white bg-electric-600 border border-transparent rounded-md shadow-sm hover:bg-electric-700 focus:outline-hidden focus:ring-2 focus:ring-offset-2 focus:ring-electric-500 sm:col-start-2 sm:text-sm"
                                        type="button"
                                        @click="reactivate">I Agree
                                </button>
                                <button ref="cancelButtonRef"
                                        class="inline-flex justify-center w-full px-4 py-2 mt-3 text-base font-medium text-gray-700 bg-white border border-clay-500 rounded-md shadow-sm hover:bg-gray-50 focus:outline-hidden focus:ring-2 focus:ring-offset-2 focus:ring-electric-500 sm:mt-0 sm:col-start-1 sm:text-sm"
                                        type="button" @click="closeConfirmation">Cancel
                                </button>
                            </div>
                            <div v-else class="mt-5 sm:grid sm:grid-flow-row-dense">
                                <button ref="cancelButtonRef"
                                        class="inline-flex justify-center w-full px-4 py-2 mt-3 text-base font-medium text-gray-700 bg-white border border-clay-500 rounded-md shadow-sm hover:bg-gray-50 focus:outline-hidden focus:ring-2 focus:ring-offset-2 focus:ring-electric-500 sm:mt-0 sm:col-start-1 sm:text-sm"
                                        type="button" @click="closeConfirmation">Ok
                                </button>
                            </div>
                        </DialogPanel>
                    </TransitionChild>
                </div>
            </div>
        </Dialog>
    </TransitionRoot>
</template>


<script lang="ts" setup>
// @ts-ignore
import {onMounted, ref, Ref} from 'vue';
import {Dialog, DialogPanel, DialogTitle, TransitionChild, TransitionRoot} from '@headlessui/vue';
import {CheckIcon} from '@heroicons/vue/20/solid';
import {client} from "@/shared";
import {GetMembershipSummary, GetMembershipSummaryResponse, ReactivateProMembership} from "@/dtos";

let processing = ref(false);
let reactivated = ref(false);
let isOpen = ref(false);

let membershipSummary = ref({});


const openConfirmation = async () => {
    isOpen.value = true;
}

const closeConfirmation = async () => {
    isOpen.value = false;
}

onMounted(async () => {
    await client.get<GetMembershipSummaryResponse>(new GetMembershipSummary())
        .then(response => {
            membershipSummary.value = response;
        });
});

const reactivate = async () => {
    processing.value = true;
    await client.post<GetMembershipSummaryResponse>(new ReactivateProMembership())
        .then(response => {
            processing.value = false;
            reactivated.value = true;
        });
}
</script>
